import { BCMSDate, BCMSRecord, Branding, DisabledPrompt, useBCMSContext, useParams, useRoute } from "@bcm-dev/bcms-vite";
import { Card } from "model";
import React from "react";

import MainContentContainer, { MainContentHeader, MainContentSection } from "components/shared/containers/MainContentContainer";
import BaseRowView from "components/shared/views/BaseRowView";

import "./styles.css";

/**
 * @function MessagesPage
 * @return {React.Component}
 * @exported true
 * @description The main component for MessagesPage
 */
export default function MessagesPage(props) {
  const controller = useBCMSContext();
  BCMSRecord.globalControllerFor([ Card ], controller);

  const navigate = useRoute();
  const cardID = useParams().cardID ?? "0";

  const cards = Card.initAll().filter(item => item.id === "1" || item.id === "0", []);
  const name = controller.state.user.name;
  //Patricia has updated the Transaction control settings for Debit card ending in *0021
  const cardRows = cards.map(item => {
    return (
      <Branding id={ item.type === "debit" ? "include_debit_chw23" : "include_credit_chw23" } value="true" key={ `Message_${ item.id }` }>
        <DisabledPrompt>
          <BaseRowView
            mainText={ `${ name } has updated the Transaction control settings for ${ item.type.charAt(0).toUpperCase() }${ item.type.slice(1) } card ending in ${ item.maskedNumber }` }
            subText={ `${ BCMSDate.init().offset(-15).format("M d, Y") } 9:02 PM` } />
        </DisabledPrompt>
      </Branding>
    );
  }, []);

  return(

      <MainContentContainer className="messages-page" header={
        <MainContentHeader text="Messages"  />
      }>
        <MainContentSection text="Card and Account Alerts">
          { cardRows }
        </MainContentSection>
      </MainContentContainer>
  
  );
}